const config = window.Settings;

export default config;